module.exports = __webpack_public_path__ + "static/media/mimi7.ace546bd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mimi7.gif
// module id = 299
// module chunks = 0